import type { Crumb } from "@/shared/components";

const ROOT_LABELS: Record<string, string> = {
  dashboard: "Home",
  catalogs: "Catalogs",
  documents: "Documents",
  reports: "Reports",
  modules: "Modules",
  settings: "Settings",
  administration: "Administration",
  app: "App",
};

const titleCase = (s: string): string =>
  s ? s.charAt(0).toUpperCase() + s.slice(1) : s;

export function deriveBreadcrumbs(pathname: string): Crumb[] {
  const home: Crumb = { label: "Home", to: "/dashboard" };
  const segments = pathname.split("/").filter(Boolean);
  if (segments.length === 0 || (segments.length === 1 && segments[0] === "dashboard")) {
    return [home];
  }
  const crumbs: Crumb[] = [home];
  segments.forEach((seg, i) => {
    const isLast = i === segments.length - 1;
    const known = ROOT_LABELS[seg];
    // First segment: prefer a friendly root label; deeper segments keep their raw key.
    const label = i === 0 ? (known ?? titleCase(seg)) : seg;
    const to = isLast ? undefined : "/" + segments.slice(0, i + 1).join("/");
    crumbs.push({ label, to });
  });
  return crumbs;
}
